export const FOOSHI_API_URL = `https://api.fooshi.co/`
// export const FOOSHI_API_URL = `http://localhost:3000/`



// WEBPACK FOOTER //
// ./src/.env.js